import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { initColorModeFromStorage } from '@smms/design-system';
import App from './App';
import { AuthProvider } from './auth/AuthContext';

// Design-system semantic tokens (light + dark) — must precede the Tailwind
// layer so component classes resolve var(--color-*) at first paint.
import '@smms/design-system/tokens/global.css';
import './index.css';

// Apply the user's color-mode choice (or OS preference) BEFORE React renders
// so the first frame doesn't flash the wrong mode.
initColorModeFromStorage();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Entitlement denials (403/404) are terminal — retrying only delays
        // the "not enabled" state.
        const status = (error as { status?: number })?.status;
        if (status === 403 || status === 404 || status === 401) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </QueryClientProvider>,
);
